<template>
    <div class="wrapper BotViewHeader">
        <div class="bot-icon mr-2" @click="toggleBotPicker" style="cursor: pointer">
            {{ getBotIconName(bot ? bot.name : '') }}
        </div>
        <div>
            <v-tooltip right slot="activator">
                <v-layout align-center slot="activator" @click="toggleBotPicker" style="cursor: pointer">
                    <span class="bot_name">{{ bot ? bot.name : '' }}</span>
                    <v-icon color="#fff">mdi-chevron-down</v-icon>
                </v-layout>
                <span>{{ bot ? bot.name : '' }}</span>
            </v-tooltip>
            <v-layout align-center style="color: #b2b4c6">
                <template v-if="isBotPin()">
                    <v-icon
                        slot="activator"
                        class="text-shadow-1 my-0 mr-1"
                        color="#ffeb3b"
                        @click="pinBot"
                        small
                    >mdi-star</v-icon>
                    <span>Pinned</span>
                </template>
                <template v-else>
                    <v-icon
                        slot="activator"
                        class="text-shadow-1 my-0 mr-1"
                        color="#b2b4c6"
                        @click="pinBot"
                        small
                    >mdi-star</v-icon>
                    <span>Pin</span>
                </template>
            </v-layout>
        </div>
        <v-spacer></v-spacer>
        <v-btn
            v-if="showNotificationGroup"
            icon
            small
            style="background: #fff;margin: 0 18px 0 0;"
            @click="toggleNotificationGroup"
        >
            <v-icon color="#0052CC">mdi-close</v-icon>
        </v-btn>
        <div style="margin-right: 18px" v-else>
            <v-tooltip right nudge-left="8" nudge-bottom="0" open-delay="0" :disabled="unreadUserNotifies.total < 9">
                <v-badge right color="#E53737" slot="activator">
                    <template v-slot:badge>
                        <span v-if="unreadUserNotifies.total > 0" @click="toggleNotificationGroup" style="cursor: pointer">
                            {{ parseCount(unreadUserNotifies.total) }}
                        </span>
                    </template>
                    <v-btn icon class="ma-0" @click="toggleNotificationGroup">
                        <img src="/icon/bell.svg" alt="">
                    </v-btn>
                </v-badge>
                <span>{{unreadUserNotifies.total}}</span>
            </v-tooltip>
        </div>
        <Menu :user="user" :bot_allow_sla_monitor="bot_allow_sla_monitor"></Menu>
        <DialogBotPicker ref="BotPicker"></DialogBotPicker>
    </div>
</template>

<script>
import Menu from "components/botview/Menu";
import _ from 'lodash';
import {mapMutations, mapState} from "vuex";
import UserService from "@/services/user.service";
import utils from "@/services/utils"
import DialogBotPicker from "@/components/dialog/DialogBotPicker";

export default {
        name: "BotViewHeader",
        props: {
        bot_allow_sla_monitor: {
                type: String,
                default: "0"
            }
    },
        components: { DialogBotPicker, Menu },
        data () {
            return {
                showNotificationGroup: false
            }
        },
        computed: {
            ...mapState(['user', 'token', 'botList', 'botListPin', 'bot', 'unreadUserNotifies']),
            ...mapState('config', ['userConfig'])
        },
        mounted () {
            this.$EventBus.$on(this.$EventBusType.NOTIFICATION_GROUP, this.toggleNotificationGroupHandler);
        },
        destroyed() {
            this.$EventBus.$off(this.$EventBusType.NOTIFICATION_GROUP, this.toggleNotificationGroupHandler);
        },
        watch: {
            '$route.params.bot_code': {
                handler () {
                    this.getBot();
                }
            },
            userConfig(val) {
                UserService.getBotList()
                    .then((res) => {
                        this.$store.commit(this.$ActionTypes.BOT_LIST, res.data);
                        UserService.updateBotListPin(val['pinnedBots'])
                    })
                    .then(()=> {
                        this.getBot();
                    });
            }
        },
        methods: {
            ...mapMutations('dialog', ['toggleBotPicker']),
            isBotPin () {
                let botCode = this.$route.params.bot_code;
                return !!_.find(this.$store.state.botListPin, bot => bot.code === botCode)
            },
            pinBot () {
                UserService.pinBot(
                    this.$route.params.bot_code,
                    !this.isBotPin()
                ).then(
                    result => UserService.updateBotListPin(result.data.pinned_bots)
                );
            },
            getBot () {
                let botCode = this.$route.params.bot_code;
                if (botCode) {
                    let bot = _.find(this.botList, item => item.code === botCode)
                    if (bot) {
                        this.$store.commit(this.$ActionTypes.BOT, bot)
                    } else {
                        this.updateBotList();
                    }
                } else {
                    let bot = this.botListPin.length > 0 ? this.botListPin[0] : this.botList[0]
                    if (!bot) {
                      window.location.href = process.env.VUE_APP_FPTAI_BOT_HOST;
                    }
                  this.$router.push(`/bot/${bot.code}`)
                }
            },
            updateBotList () {
                UserService.getBotList().then(response => {
                    let botList = response.data;
                    this.$store.commit(this.$ActionTypes.BOT_LIST, botList);
                    return botList;
                }).then((botList) => {
                    if (botList.length > 0) {
                        let botCode = this.$route.params.bot_code;
                        let bot = _.find(this.botList, function (o) {
                            return o.code === botCode;
                        });
                        if (bot) {
                            this.$store.commit(this.$ActionTypes.BOT, bot)
                        }
                    }
                })
            },
            getBotIconName: utils.getBotIconName,
            toggleNotificationGroup () {
                this.$EventBus.$emit(this.$EventBusType.NOTIFICATION_GROUP, !this.showNotificationGroup)
            },
            toggleNotificationGroupHandler (payload) {
                this.showNotificationGroup = payload
            },
            parseCount(count) {
                return count > 9 ? '9+' : count
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../style/bot-view-header.scss";

    .BotViewHeader::v-deep .v-badge__badge {
        top: 3px;
        right: -3px;
    }
</style>
